import { useGetPrePurchasesQuery } from '@/features/slice/purchases';
import { useUrlFilter } from '@/hooks';
import { TQueryFilterParams } from '@/types';

export const usePrePurchaseList = () => {
    const { debouncedSearchText } = useUrlFilter();

    const queryParams: TQueryFilterParams = {};

    if (debouncedSearchText) {
        queryParams['search'] = debouncedSearchText;
    }

    const { data, isError, isLoading, isFetching, error } =
        useGetPrePurchasesQuery(queryParams);

    return {
        data,
        isError,
        isLoading,
        isFetching,
        error,
    };
};
